








import GetUsersMessagesQuery from '@/graphql/queries/getUsersMessages.gql';
import request, { requestPaginated } from '@/graphql/request';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import MessageDisplay from '@/components/MessageDisplay.vue';
import HatsuiTableDisplay from '@/components/HatsuiTableDisplay.vue';
import { setInterval, clearTimeout } from 'timers';
import IMessage from '../interfaces/message';

@Component({
  components: {
    MessageDisplay,
    HatsuiTableDisplay,
  },
})
export default class DataStream extends Vue {
  public messages: IMessage[] = [];
  public refreshMessageTimer: NodeJS.Timeout | null = null;

  private cursor?: string = undefined;
  private take = 100;

  public mounted() {
    this.nextMessages();
    this.refreshMessageTimer = setInterval(this.nextMessages, 30000);
  }

  public async nextMessages() {
    const page = await requestPaginated<IMessage>(
      'getUsersMessages',
      GetUsersMessagesQuery,
      { last: this.take  }
    );

    // this.cursor = page.pageInfo.startCursor || undefined;
    
    if (page.nodes && page.nodes.length) {
      this.messages = [...page.nodes].reverse();
      // this.messages = [...page.nodes, ...this.messages];
    }
  }

  public destroyed() {
    clearTimeout(this.refreshMessageTimer as NodeJS.Timeout);
    this.refreshMessageTimer = null;
  }
}
